import { styled } from '@mui/system';
import * as React from 'react';
import { useEffect, useState } from 'react';
import NoteCardGroup from './components/NoteCardGroup';
import { useLocation } from 'react-router-dom';
import { useGetFollowNoteMutation } from '../../store/api/userApi';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserBroad from './components/UserBroad';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/auth/authSlice';
import { useContext } from 'react';
import { AppContext } from '../../context/ContextProvider';
import { extractIdFromURL } from '../../utils/common';
import { Navigate } from 'react-router-dom';

const FeedPageContainer = styled('div')(({ theme }) => ({
  padding: '30px',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',

  [theme.breakpoints.down('600')]: {
    padding: '15px 0',
    gap: '10px',
  },
}));

const NoteFeedPage = () => {
  const currentUserId = useSelector(selectUser);
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  const location = useLocation();
  const id = extractIdFromURL(location.pathname)
    ? extractIdFromURL(location.pathname)
    : currentUserId;

  let [pageData, setPageData] = useState({
    list: [],
    hasMore: true,
    pageNum: 1,
  });
  const [getNote] = useGetFollowNoteMutation();
  const noteNum = 2;
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async (flag) => {
    flag &&
      setPageData({
        ...pageData,
        pageNum: pageData.pageNum++,
      });
    let { data: note } = await getNote({
      id,
      noteNum,
      pageNum: pageData.pageNum,
    });
    if (note.data.length == 0) {
      setPageData({
        ...pageData,
        hasMore: false,
      });
      return;
    }
    if (flag) {
      const list = pageData.list;
      list.push(...note.data);
      setPageData({
        ...pageData,
        list,
      });
    } else {
      setPageData({
        ...pageData,
        list: [...note.data],
      });
    }
  };

  const linkUrl = `/search`;
  useEffect(() => {
    if (!isLogin) {
      setIsShow(false);
    }
  }, [isLogin, isShow]);

  return isLogin ? (
    <InfiniteScroll
      dataLength={pageData.list.length} //This is important field to render the next data
      next={() => {
        fetchData(true);
      }}
      hasMore={pageData.hasMore}
      loader={
        <h3 style={{ textAlign: 'center' }}>
          You are not following anyone. Or,you followings haven't posted.
          <br />
          <br />
          <a href={linkUrl} underline="none">
            Discover more notes
          </a>
        </h3>
      }
      endMessage={
        <p style={{ textAlign: 'center' }}>
          <b>Yay! You have seen it all </b>
        </p>
      }
      // below props only if you need pull down functionality
      refreshFunction={() => {}}
      pullDownToRefresh
      pullDownToRefreshThreshold={50}
      pullDownToRefreshContent={
        <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
      }
      releaseToRefreshContent={
        <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
      }
    >
      <FeedPageContainer>
        <UserBroad />
        <NoteCardGroup NoteFeedData={pageData.list} />
      </FeedPageContainer>
    </InfiniteScroll>
  ) : (
    <Navigate to="/signin" />
  );
};

export default NoteFeedPage;
